/* eslint-disable react/prefer-es6-class, react/sort-comp, react/jsx-closing-bracket-location */
import classnames from 'classnames';
import React from 'react';
import { t } from 'es6/services/localization';
import { humanizedTime } from 'es6/helpers/time';
import { NavButton, Navigation } from 'es6/components/apps/navigation';
import { ProgressBarSentenceTrainer } from 'es6/components/common/progress-bar';
import ResultGlyphs from 'es6/components/apps/result-glyphs';
import SentenceTrainerSummaryBreakdown from 'es6/components/apps/screens/sentence-trainer-summary-breakdown';
import SentenceTrainerSummaryMixin from 'es6/components/apps/mixins/sentence-trainer-summary';
import SoundManager from 'es6/services/sound-manager';
import { Stats, Stat, StatData, StatLabel } from 'es6/components/apps/stats';
import { DONE } from 'es6/core/sound-effects';

export default React.createClass({
  displayName: 'SentenceTrainerSummaryScreen',

  mixins: [SentenceTrainerSummaryMixin],

  propTypes: {
    onNext: React.PropTypes.func.isRequired,
    presentationResults: React.PropTypes.array.isRequired,
    sessionData: React.PropTypes.object.isRequired,
    sessionResults: React.PropTypes.object.isRequired,
    studyAll: React.PropTypes.bool.isRequired,
  },

  getInitialState() {
    return {
      isViewingSentenceBreakdown: false,
    };
  },

  componentDidMount() {
    SoundManager.playEffect(DONE);
  },

  _toggleScreenContent(e) {
    e.preventDefault();
    this.setState({ isViewingSentenceBreakdown: !this.state.isViewingSentenceBreakdown });
  },

  render() {
    if (this.state.isViewingSentenceBreakdown) {
      return this._renderSentenceBreakdown();
    }

    const className = classnames('screen screen-sentence-trainer-summary', {
      'screen-sentence-trainer-summary-study-all': this.props.studyAll,
    });

    // Determine the amount of correct/mistakes/incorrect for each presentation result.
    const sentenceTrainerResults = this._getSentenceTrainerResults();

    let correct = 0;
    let mistakes = 0;
    let incorrect = 0;

    sentenceTrainerResults.forEach(result => {
      if (result.resultGlyph === ResultGlyphs.CORRECT) {
        correct++;
      } else if (result.resultGlyph === ResultGlyphs.CORRECT_WITH_MISTAKES) {
        mistakes++;
      } else {
        incorrect++;
      }
    });

    return (
      <div className={className}>
        <div className="screen-content">
          <h4 className="header">{t('session-results')}</h4>

          <div className="summary">
            {this._renderCourseDetails()}

            <ul className="summary-stats">
              <li className="correct">
                <div className={`secondary-item ${ResultGlyphs.CORRECT}`} />
                <div className="primary-item">
                  <span className="primary sentences_correct">{correct}</span>
                  {' '}
                  <span className="secondary">{t('js_iknow.correct')}</span>
                </div>
              </li>
              <li className="with_misses">
                <div className={`secondary-item ${ResultGlyphs.CORRECT_WITH_MISTAKES}`}></div>
                <div className="primary-item">
                  <span className="primary sentences_with_misses">{mistakes}</span>
                  {' '}
                  <span className="unit">{t('with misses')}</span>
                </div>
              </li>
              <li className="incorrect">
                <div className={`secondary-item ${ResultGlyphs.INCORRECT}`}></div>
                <div className="primary-item">
                  <span className="primary sentences_incorrect">{incorrect}</span>
                  {' '}
                  <span className="unit">{t('incorrect')}</span>
                </div>
              </li>
            </ul>
          </div>

          <div className="session-details">
            <a onClick={this._toggleScreenContent}>{t('js_iknow.details')}</a>
          </div>
        </div>

        <Navigation>
          <NavButton align="right" focused onClick={this.props.onNext}>{t('js_iknow.next')}</NavButton>
        </Navigation>
      </div>
    );
  },

  _renderCourseDetails() {
    if (this.props.studyAll) {
      return null;
    }

    const { presentationResults,
           sessionData,
           sessionResults } = this.props;

    const aggregateMemory = sessionResults.goalMemoryAggregates[0] || sessionData.aggregateMemory[0];
    const goal = this.props.sessionData.goals[0];

    const progress = aggregateMemory.sentences.progress;
    const level = aggregateMemory.sentences.level;

    const started = sessionData.studySession.length;
    const totalTimeMillis = presentationResults.reduce((prev, pr) => pr.studyTimeMillis + prev, 0);
    const totalTime = totalTimeMillis / 1000;

    return (
      <div className="course-details">
        <h4 className="level">{t('st-level-{level}', { level })}</h4>
        <h2 className="title ellipsis">{goal.title}</h2>

        <ProgressBarSentenceTrainer progress={progress} />

        <div className="stats-container">
          <Stats>
            <Stat type="started">
              <StatData>{started}</StatData>
              <StatLabel>{t('times')}</StatLabel>
            </Stat>

            <Stat type="time">
              <StatData>{humanizedTime(totalTime)}</StatData>
              <StatLabel>{t('js_iknow.study time')}</StatLabel>
            </Stat>
          </Stats>
        </div>

        <div className="hr"></div>
      </div>
    );
  },

  _renderSentenceBreakdown() {
    return (
      <SentenceTrainerSummaryBreakdown
        onBack={this._toggleScreenContent}
        presentationResults={this.props.presentationResults}
        sessionData={this.props.sessionData} />
    );
  },
});
